import productListReducer, {
    ProductListActions,
} from "@toolkit/Framework/Store/Toolkit/Pages/ProductList/ProductListReducer";
import { combineReducers } from "redux";

const pagesReducer = combineReducers({
    productList: productListReducer,
});

export type PagesActions = ProductListActions;

export default pagesReducer;
